import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const TestSuiteApi = {
    getTestChannel: (options?: BaseApiQueryOptions) => apiQueryOptions(['testSuite', 'getTestChannel'], (api) => api.testSuite.getTestChannel(), options)
};
